import React, { useEffect, useState } from "react";
import { Button, FormFieldSet, showToast } from "../../../../../components";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  createInstantlyCampaign,
  successCreateInstantlyCampaign,
} from "../../../../../redux/slices/compaigns/compaignsSlice";

const CampaignName = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [campaignName, setCampaignName] = useState("");
    const createCampaigns =useSelector((state) => state.compaigns?.instantly?.createCampaigns) || {};
  const handleCallApi = async () => {
    const payload = {
      name: campaignName?.trim(),
    };
    dispatch(successCreateInstantlyCampaign(payload));
    // navigate("/ats/campaigns/add-campaign#leads")
    navigate("/ats/campaigns/add-campaign?add-campaign=leads");
  };
 useEffect(() => {
  if (createCampaigns && Object.keys(createCampaigns).length > 0) {
    setCampaignName(createCampaigns?.name);
  }
}, [createCampaigns]);

  return (
    <div className="flex items-end gap-5 py-4 px-2">
      <FormFieldSet
        title="Campaign Name"
        placeholder="Campaign Name"
        value={campaignName}
        onChange={(value) => setCampaignName(value)}
      />
      <Button
        title={"Next"}
        disabled={!campaignName?.trim()}
        onClick={() => handleCallApi()}
      />
    </div>
  );
};

export default CampaignName;
